(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.t4s-faq-question');
  if (!btn) return;

  const item = btn.closest('.t4s-faq-item');
  if (!item) return;

  item.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
});

  } catch(e) { console.error(e); }
})();
})();
